export default "__VITE_PUBLIC_ASSET__22e08d79__"